import { Phone, Calculator, ArrowRight } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#151816] border-t-2 border-[#5BB239] shadow-[0_-8px_24px_rgba(0,0,0,0.25)]"
      data-testid="sticky-mobile-cta"
    >
      <div className="grid grid-cols-2 gap-px bg-white/10">
        <a
          href="tel:+15025077904"
          className="bg-[#151816] flex items-center justify-center gap-2 py-3.5 text-white font-mono-label text-[11px] uppercase tracking-widest active:bg-[#1e2320]"
          data-testid="mobile-cta-call"
        >
          <Phone className="w-4 h-4 text-[#5BB239]" />
          Call Now
        </a>
        <a
          href="#quote"
          className="bg-[#5BB239] flex items-center justify-center gap-2 py-3.5 text-white font-mono-label text-[11px] font-bold uppercase tracking-widest active:bg-[#499828]"
          data-testid="mobile-cta-quote"
        >
          <Calculator className="w-4 h-4" />
          Get Quote
          <ArrowRight className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
  );
}
